"use strict";
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    axios: true
};
Object.defineProperty(exports, "axios", {
    enumerable: true,
    get: function get() {
        return _axios.default;
    }
});
var _axios = _interopRequireWildcard(require("axios"));
Object.keys(_axios).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _axios[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _axios[key];
        }
    });
});
var _createAxiosWithCache = require("./createAxiosWithCache");
Object.keys(_createAxiosWithCache).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _createAxiosWithCache[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _createAxiosWithCache[key];
        }
    });
});
var _joinPathSegments = require("./joinPathSegments");
Object.keys(_joinPathSegments).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _joinPathSegments[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _joinPathSegments[key];
        }
    });
});
var _SafeURL = require("./SafeURL");
Object.keys(_SafeURL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _SafeURL[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _SafeURL[key];
        }
    });
});
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != (typeof e === "undefined" ? "undefined" : _type_of(e)) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _$t in e)"default" !== _$t && ({}).hasOwnProperty.call(e, _$t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _$t)) && (i.get || i.set) ? o(f, _$t, i) : f[_$t] = e[_$t]);
        return f;
    })(e, t);
} //# sourceMappingURL=index.js.map
